module.exports = __webpack_public_path__ + "static/media/Glacial-Indifference.52351f96.svg";